import { PERMISSIONS } from '@pms/shared';
import { useAuth } from '@/hooks/useAuth';
import { usePermission } from '@/hooks/usePermission';
import { GreetingHero } from './widgets/GreetingHero';
import { AdminKPIs } from './widgets/AdminKPIs';
import { ManagerKPIs } from './widgets/ManagerKPIs';
import { UserKPIs } from './widgets/UserKPIs';
import { AttendanceWidget } from './widgets/AttendanceWidget';
import { LeaveWidget } from './widgets/LeaveWidget';
import { TasksWidget } from './widgets/TasksWidget';
import { ApprovalsQueueWidget } from './widgets/ApprovalsQueueWidget';
import { SopWidget } from './widgets/SopWidget';
import { FinanceWidget } from './widgets/FinanceWidget';
import { RecruitmentWidget } from './widgets/RecruitmentWidget';
import { QuickActionsWidget } from './widgets/QuickActionsWidget';
import { NotificationsWidget } from './widgets/NotificationsWidget';
import { UnavailableWidget } from './widgets/UnavailableWidget';
import { BirthdayWidget } from './widgets/BirthdayWidget';
import { AnniversaryWidget } from './widgets/AnniversaryWidget';

function AdminLayout() {
  return (
    <div className="space-y-4">
      <AdminKPIs />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        <div className="md:col-span-2">
          <AttendanceWidget isAdminTier isManagerTier={false} />
        </div>
        <ApprovalsQueueWidget />
      </div>
      <UnavailableWidget />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        <LeaveWidget isAdminTier isManagerTier={false} />
        <TasksWidget isAdminTier isManagerTier={false} />
        <SopWidget isAdminTier />
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        <FinanceWidget isAdminTier />
        <RecruitmentWidget />
        <NotificationsWidget />
      </div>
      <QuickActionsWidget isAdminTier isManagerTier={false} />
    </div>
  );
}

function ManagerLayout() {
  return (
    <div className="space-y-4">
      <ManagerKPIs />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        <div className="md:col-span-2">
          <AttendanceWidget isAdminTier={false} isManagerTier />
        </div>
        <LeaveWidget isAdminTier={false} isManagerTier />
      </div>
      <UnavailableWidget />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        <div className="md:col-span-2">
          <TasksWidget isAdminTier={false} isManagerTier />
        </div>
        <SopWidget isAdminTier={false} />
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <ApprovalsQueueWidget />
        <NotificationsWidget />
      </div>
      <QuickActionsWidget isAdminTier={false} isManagerTier />
    </div>
  );
}

function UserLayout() {
  return (
    <div className="space-y-4">
      <UserKPIs />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <AttendanceWidget isAdminTier={false} isManagerTier={false} />
        <LeaveWidget isAdminTier={false} isManagerTier={false} />
      </div>
      <UnavailableWidget />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <TasksWidget isAdminTier={false} isManagerTier={false} />
        <SopWidget isAdminTier={false} />
      </div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <FinanceWidget isAdminTier={false} />
        <NotificationsWidget />
      </div>
      <QuickActionsWidget isAdminTier={false} isManagerTier={false} />
    </div>
  );
}

export function DashboardPage() {
  const { user, roles, isSuperAdmin } = useAuth();
  const { has } = usePermission();

  const isAdminTier = isSuperAdmin || has(PERMISSIONS.LEAVE_VIEW_ALL);
  const isManagerTier = !isAdminTier && (has(PERMISSIONS.LEAVE_APPROVE) || has(PERMISSIONS.ATTENDANCE_VIEW_TEAM));
  const isUserTier = !isAdminTier && !isManagerTier;

  const hour = new Date().getHours();
  const greeting =
    hour < 12 ? 'Good morning' : hour < 17 ? 'Good afternoon' : 'Good evening';
  const firstName = user?.first_name ?? user?.email ?? 'there';
  const today = new Date().toLocaleDateString('en-IN', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  return (
    <div className="space-y-6 pb-8">
      <GreetingHero
        greeting={greeting}
        firstName={firstName}
        today={today}
        roles={roles}
        isAdminTier={isAdminTier}
        isManagerTier={isManagerTier}
      />

      <BirthdayWidget />
      <AnniversaryWidget />

      {isAdminTier && <AdminLayout />}
      {isManagerTier && <ManagerLayout />}
      {isUserTier && <UserLayout />}
    </div>
  );
}
